import {Injectable, inject, signal} from '@angular/core';
import { CmsApiService } from './api/cms-api.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import {CountryType} from "ngx-unificator/types/cms";
import {CountryList$} from "../helpers/user/user-fields.data";

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private _api = inject(CmsApiService);

  public loaded = signal<boolean>(false);
  public countryList = signal<CountryType[]>([]);

  /**
   * Load countries from backend
   *
   * @public
   */
  public loadCountries() {
    return this._api.countryList().pipe(
      catchError(error => of({data: []})),
      tap(response => {
        this.countryList.set(response.data || []);
        CountryList$.next(this.countryList());
        this.loaded.set(true);
      })
    );
  }

  /**
   * Returns name of country by country short code
   *
   * @param short
   */
  public countryName(short: string): string {
    return (this.countryList()?.find(country => country.short === short.toLowerCase()) || {}).name || '';
  }
}
